import React from 'react';

import Historia from '../../components/Historia/Historia';
import Servicios from '../../components/Servicios/Servicios';

import fotoFrente from '../../assets/img/site/rango-fotoFrente.jpg'

const QuienesSomos = () => {
	return (
		<>
			<div className="spaceNav"></div>
			<Historia />
			<Servicios />
			<section className="dark last">
				<div className="container">
					<div className="row">

						<div className="col-sm-7">
							<div className="content-box">
								<div className="img-box left">
									<img className="img-fluid" src={fotoFrente} alt="Frente Rango Comercial" />
								</div>
							</div>
						</div>
						<div className="col-sm-5">
							<div className="py-5">
								<h2 className="big dark-title"><span>UN CENTRO</span><span>DE DISTRIBUCIÓN</span>ESTRATÉGICO</h2>
								<p className="my-4">Nuestro centro de distribución en La Pampa cuenta
									con la última tecnología disponible para garantizar una
									óptima operación. Desde la tecnología de identificación
									de mercadería, hasta el sistema de picking de pedidos,
									toda la cadena se encuentra optimizada para ofrecerle
									la mejor experiencia de compra (texto a modo de
									ejemplo, ampliar con un contenido que genere valor
									para el cliente y que represente a Rango Comercial).</p>
							</div>
						</div>

					</div>
				</div>
			</section>
		</>
	);
}

export default QuienesSomos;
